import { getIsOversea } from '@telecom/shared/utils/environment';
import { NoveltyCheckTaskStep } from '../enums';

/**
 * 技术特征颜色映射,字体为白色时候的背景颜色
 */
export const TECHNICAL_FEATURE_COLOR_ARR = [
    '#B5DAA6',
    '#82C3FF',
    '#82D7E4',
    '#F1CB9C',
    '#D4B9EB',
    '#EDA3AD',
];

/**
 * 技术特征颜色映射,字体为黑色时候的背景颜色
 */
export const TECHNICAL_FEATURE_BG_COLOR_ARR = [
    '#E3F1DE',
    '#DDEBF8',
    '#D4F0F6',
    '#FAECDA',
    '#E2D5ED',
    '#F8DDE0',
];

/**
 * 技术特征字母
 */
export const TECHNICAL_FEATURE_LETTERS = 'abcdefghijklmnopqrstuvwxyz';

/**
 * 技术特征编辑器最大字数
 */
export const TECHNICAL_FEATURE_MAX_TEXT_LENGTH = 1000;

/**
 * 查新报告输入框输入最大字数
 */
export const NOVELTY_CHECK_INPUT_MAX_LENGTH = 5000;

/**
 * 查新报告触发要点总结的字符阈值（2000 字符）
 */
export const NOVELTY_CHECK_TRIGGER_POINT_SUMMARY_MIN_LENGTH = 0;

/**
 * 查新报告输入框输入最小字数
 */
export const NOVELTY_CHECK_INPUT_MIN_LENGTH = 50;

/**
 * 检索策略名称
 */
export enum RETRIEVAL_STRATEGY {
    /**
     * 语义检索
     */
    SEMANTIC_SEARCH = 'semantic_search',
    /**
     * 分类号检索
     */
    IPC_CPC_SEARCH = 'ipc_cpc_search',
    /**
     * 第 1 次块检索
     */
    BLOCK_PROGRESSIVE_SEARCH_1 = 'block_progressive_search_1',
    /**
     * 第 2 次块检索
     */
    BLOCK_PROGRESSIVE_SEARCH_2 = 'block_progressive_search_2',
    /**
     * 第 3 次块检索
     */
    BLOCK_PROGRESSIVE_SEARCH_3 = 'block_progressive_search_3',
    /**
     * 第 4 次块检索
     */
    BLOCK_PROGRESSIVE_SEARCH_4 = 'block_progressive_search_4',
    /**
     * 相关跟踪检索
     */
    RELEVANT_TRACKING_SEARCH = 'relevant_tracking_search',
}

/**
 * 输入的语言不符合要求错误
 */
export const ERROR_INPUT_LANGUAGE_NOT_SATISFIED = 'INPUT_LANGUAGE_NOT_SATISFIED';

/**
 * 输入过长错误
 */
export const ERROR_INPUT_TOO_LONG = 33120013;

/**
 * 人工每篇专利检索+对比耗时：5 + 5，单位：秒
 */
export const HUMAN_RETRIEVAL_PER_PATENT_TIME = 5 * 60 + 5 * 60;

/**
 * 技术特征对比最大选择数量
 */
export const TECHNICAL_FEATURE_COMPARE_MAX_SELECTED_COUNT = getIsOversea()? 10 : 5;

/**
 * 查新支持的输入语言
 */
export const SupportedLanguages = ['cn', 'en'];

/**
 * 输入需要总结错误
 */
export const ERROR_INPUT_NEED_SUMMARY = 'ERROR_INPUT_NEED_SUMMARY';

/**
 * 显示新颖性评述的输入语言
 */
export const REVIEW_INPUT_LANGUAGE = 'CN';

/**
 * 查新报告路由名称
 */
export const NOVELTY_ROUTER_NAME= 'novelty-check-report';

/**
 * 技术特征输入框最大字数
 */
export const TECHNICAL_FEATURE_INPUT_MAX_LENGTH = 200;

/**
 * 核心技术特征最小标记数量
 */
export const TECHNICAL_FEATURE_FLAG_MIN_COUNT = 3;

/**
 * 核心技术特征最大标记数量
 */
export const TECHNICAL_FEATURE_FLAG_MAX_COUNT = 5;

/**
 * 技术特征对话框最大选择数量
 */
export const TECHNICAL_FEATURE_DIALOG_MAX_SELECTED_COUNT = 6;

/**
 * 数据版本过期错误码
 */
export const DATA_VERSION_EXPIRED_CODE = 33110005;

/**
 * 回放时按步骤进行的顺序
 */
export const STEPS_ORDER: NoveltyCheckTaskStep[] = [
    NoveltyCheckTaskStep.INITIAL,
    NoveltyCheckTaskStep.SUMMARY,
    NoveltyCheckTaskStep.NOVELTY_SEARCH_INPUT,
    NoveltyCheckTaskStep.NOVELTY_SEARCH_TECH_FEATURE,
    NoveltyCheckTaskStep.NOVELTY_SEARCH_RETRIEVAL_ELEMENTS,
    NoveltyCheckTaskStep.SEARCH_FINISHED,
    NoveltyCheckTaskStep.PATENT_CONFIRM,
    NoveltyCheckTaskStep.GENERATE_FEATURE_COMPARE_TABLE,
    NoveltyCheckTaskStep.REPORT_CREATED,
];

/**
 * 1.总结技术方案  26s
 * 2.提取技术特征  16s
 * 3.检索要素提取  21s
 * 4.检索策略   222s
 *    4.1 语义检索  40s
 *    4.2 第一轮  26s
 *    4.3 第二轮  9s
 *    4.4 第三轮  24s
 *    4.5 第四轮  25s
 *    4.6 第五轮  28s
 *    4.7 追踪检索  21s
 * 7.生成报告  40s
 */

/**
 * 步骤平均耗时，单位：秒
 */
export const STEPS_AVERAGE_SPENT_SECONDS: Partial<Record<NoveltyCheckTaskStep, number>> = {
    [NoveltyCheckTaskStep.INITIAL]: 0,
    [NoveltyCheckTaskStep.SUMMARY]: 26,
    [NoveltyCheckTaskStep.NOVELTY_SEARCH_INPUT]: 0,
    [NoveltyCheckTaskStep.NOVELTY_SEARCH_TECH_FEATURE]: 16,
    [NoveltyCheckTaskStep.NOVELTY_SEARCH_RETRIEVAL_ELEMENTS]: 21,
    [NoveltyCheckTaskStep.SEARCH_FINISHED]: 222,
    [NoveltyCheckTaskStep.PATENT_CONFIRM]: 0,
    [NoveltyCheckTaskStep.GENERATE_FEATURE_COMPARE_TABLE]: 0,
    [NoveltyCheckTaskStep.REPORT_CREATED]: 40,
};

export const DEEPSEARCH_STEPS_AVERAGE_SPENT_SECONDS = [
    40,
    26,
    9,
    24,
    // 25,
    // 28,
    21,
];
